import React, { UIEvent, useEffect, useRef } from 'react';
import cx from 'classnames';
import parse from 'html-react-parser';
import styles from './CardReader.module.scss';
import CardReaderProps from './CardReader.types';
import CardBase from '../../atoms/HeadingCard';

const CardReader = ({ className, content, onScrollComplete }: CardReaderProps) => {
  const scrollRef = useRef<HTMLDivElement>();
  const isScrollComplete = ({ scrollHeight, scrollTop, clientHeight }: HTMLDivElement): boolean => {
    const complete = scrollHeight - scrollTop - clientHeight <= 1;

    return complete;
  };
  const scrollCompleteHandler = (e: UIEvent<HTMLDivElement, any>) => {
    if (onScrollComplete) {
      const complete = isScrollComplete(e.currentTarget);
      onScrollComplete(complete);
    }
  };
  useEffect(() => {
    if (scrollRef.current) {
      if (onScrollComplete) {
        onScrollComplete(isScrollComplete(scrollRef.current));
      }
    }
  }, []);

  return (
    <div className={cx(styles.cardReader, className)}>
      <div className={cx(styles.cardScroll)} ref={scrollRef} onScroll={scrollCompleteHandler}>
        <CardBase className={styles.baseCard}>{parse(content)}</CardBase>
      </div>
    </div>
  );
};

export default CardReader;
